import * as React from 'react';
import ChartLib from 'chart.js';
import { chartDefaults } from '../../constants/chartDefaults';
export var useChartGlobals = function useChartGlobals() {
  React.useEffect(function () {
    Object.keys(chartDefaults).forEach(function (key) {
      ChartLib.defaults[key] = chartDefaults[key];
    });
  }, []);
};